// The raw-bytes hashing primitive every check in this module builds on.
//
// docs/plans/2026-08-10-verification-manifest.md §6: "the hash is over
// bytes ... no client, and no future version of our own code, may parse a
// manifest and re-encode it expecting the same hash." sha256Hex must
// therefore only ever be called on bytes taken directly off the wire — a
// fetch response's ArrayBuffer, before anything decodes or JSON.parses it.
// A JSON.parse → JSON.stringify round trip does not reproduce the original
// bytes (indentation, key order, escaping can all differ) and hashing the
// round-tripped copy produces a digest that looks wrong for reasons that
// will be very hard to track down later. See verifyRoot.ts for where this
// is applied: the hash is taken before the same bytes are ever decoded.
export async function sha256Hex(data: ArrayBuffer): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', data)
  return toHex(digest)
}

function toHex(buffer: ArrayBuffer): string {
  return Array.from(new Uint8Array(buffer))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('')
}

// The chain, the API and this module have no shared case convention for hex
// — treating "AB" and "ab" as different hashes would be a false mismatch,
// not a real one, so every hash comparison in this module goes through here
// rather than a bare `===`.
export function hexEqual(a: string, b: string): boolean {
  return a.toLowerCase() === b.toLowerCase()
}
